import {
    ReportEntry,
    ReportStatus,
    ReportType,
} from 'components/pages/Reports/types/reportsCenter';

export const reportsMock: ReportEntry[] = [
    {
        id: 'report-1',
        type: ReportType.COURSE_DETAILS,
        requestedAt: '2025-06-01T10:15:00.000Z',
        status: ReportStatus.READY,
        downloadUrl: 'https://example.com/reports/report-1.xlsx',
    },
    {
        id: 'report-2',
        type: ReportType.LP_DETAILS,
        requestedAt: '2025-06-02T14:30:00.000Z',
        status: ReportStatus.IN_PROGRESS,
        downloadUrl: null,
    },
    {
        id: 'report-3',
        type: ReportType.COURSE_DETAILS,
        requestedAt: '2025-06-03T09:00:00.000Z',
        status: ReportStatus.ERROR,
        downloadUrl: null,
    },
    {
        id: 'report-4',
        type: ReportType.LP_DETAILS,
        requestedAt: '2025-06-04T16:45:00.000Z',
        status: ReportStatus.READY,
        downloadUrl: 'https://example.com/reports/report-4.xlsx',
    },
    {
        id: 'report-5',
        type: ReportType.COURSE_DETAILS,
        requestedAt: '2025-06-05T11:20:00.000Z',
        status: ReportStatus.READY,
        downloadUrl: 'https://example.com/reports/report-5.xlsx',
    },
    {
        id: 'report-6',
        type: ReportType.LP_DETAILS,
        requestedAt: '2025-06-06T08:10:00.000Z',
        status: ReportStatus.IN_PROGRESS,
        downloadUrl: null,
    },
    {
        id: 'report-7',
        type: ReportType.COURSE_DETAILS,
        requestedAt: '2025-06-07T13:55:00.000Z',
        status: ReportStatus.READY,
        downloadUrl: 'https://example.com/reports/report-7.xlsx',
    },
    {
        id: 'report-8',
        type: ReportType.LP_DETAILS,
        requestedAt: '2025-06-08T17:40:00.000Z',
        status: ReportStatus.ERROR,
        downloadUrl: null,
    },
    {
        id: 'report-9',
        type: ReportType.COURSE_DETAILS,
        requestedAt: '2025-06-09T12:05:00.000Z',
        status: ReportStatus.IN_PROGRESS,
        downloadUrl: null,
    },
    {
        id: 'report-10',
        type: ReportType.LP_DETAILS,
        requestedAt: '2025-06-10T15:25:00.000Z',
        status: ReportStatus.READY,
        downloadUrl: 'https://example.com/reports/report-10.xlsx',
    },
];
